import getPersistenceParameters from './getPersistenceParameters';

const persistenceParameters = getPersistenceParameters();

export const apiKey = persistenceParameters['data-api-key'];
export const persistenceId = persistenceParameters['config-ft-persistence-id'];
const workflowTag = persistenceParameters['data-ft-workflow-tag'];

const persistenceKey = apiKey
  ? JSON.stringify({
      'data-api-key': apiKey,
      ...(persistenceId
        ? { 'config-ft-persistence-id': persistenceId }
        : { 'data-ft-workflow-tag': workflowTag || undefined }),
    })
  : null;

export default persistenceKey;
